import sectionBannerSliderCss from '../css-snippets/section-banner-slider';

const html = `
<style>${sectionBannerSliderCss}</style>
<div data-attribute="card-container" data-id="unique-id" data-top-padding="true" data-bottom-padding="true">
    <div class="container-page">
        <div class="wrap-card">
            <div class="swiper banner-slider mySwiperBannerSlider-unique-id">
                <div data-attribute="list-item" class="swiper-wrapper">
                    <div data-attribute="item" class="swiper-slide">
                        <div data-attribute="wrap-content" class="wrap-ct">
                            <div class="wrap-img">
                                <img loading="lazy" data-attribute="image-banner"
                                    src="https://cdn.skyfastimg.com/images/2025/08/23/image-68a987dc78cf307dbed290f4.webp?w=1200&h=50&q=80" alt="">
                            </div>
                            <div class="wrap-text-btn">
                                <div data-show-text="true" data-attribute="text-banner" class="wrap-text"
                                    style="display: block;">
                                    <h2>Buy 2 get 5% off</h2>
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.</p>
                                </div>
                                <div data-show-button="true" data-attribute="button-banner" class="wrap-btn"
                                    style="display: block;">
                                    <a data-attribute="button-link" class="btn-slide" href="#">Buy Now</a>
                                </div>
                            </div>
                            <div data-show-overlay="true" data-opacity="0.2" data-attribute="overlay-slide" class="slide-overlay"
                                style="background-color: black; opacity: 0.2; display: block;"></div>
                        </div>
                    </div>
                    <div data-attribute="item" class="swiper-slide">
                        <div data-attribute="wrap-content" class="wrap-ct">
                            <div class="wrap-img">
                                <img data-attribute="image-banner"
                                    src="https://cdn.skyfastimg.com/images/2025/08/23/image-68a987dc78cf307dbed290f4.webp?w=1200&h=50&q=80" alt="">
                            </div>
                            <div class="wrap-text-btn">
                                <div data-show-text="true" data-attribute="text-banner" class="wrap-text"
                                    style="display: block;">
                                    <h2>Buy 3 get 10% off</h2>
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.</p>
                                </div>
                                <div data-show-button="true" data-attribute="button-banner" class="wrap-btn"
                                    style="display: block;">
                                    <a data-attribute="button-link" class="btn-slide" href="#">Buy Now</a>
                                </div>
                            </div>
                            <div data-show-overlay="true" data-opacity="0.2" data-attribute="overlay-slide" class="slide-overlay"
                                style="background-color: black; opacity: 0.2; display: block;"></div>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination"></div>
            </div>
        </div>
    </div>
</div>
`;
export default html;
